import React from "react";
import "./footerCard.css"
import Logo from "./Logo";
export default function FooterCard(){
    return(
        <div className="footercard">
            <div className="footerlogo">
               <div className="footlog"  >
               <Logo />
                </div>
                <h1>WeCare.com</h1>
            </div>
            <p>We are happy to deliver our Product in your Happiness. Buy our products</p>
        </div>
    )
}